<template>
  <div>
    <div>
      <el-col :span="24">
        <div>
          <el-steps :active="wechatQrGenerateProcess" class="stepClass" align-center="true">
            <!-- <el-step title="输入网址" icon="fa fa-edit fa-2x"></el-step> -->
            <el-step><span slot="title"><i class="fa fa-edit fa-x"></i>输入微信号</span></el-step>
            <el-step><span slot="title"><i class="fa fa-upload fa-x"></i>上传图像</span></el-step>
            <el-step><span slot="title"><i class="fas fa-cut fa-x"></i>裁剪生成</span></el-step>
            <el-step><span slot="title"><i class="far fa-save fa-x"></i>保存图片</span></el-step>
          </el-steps>
        </div>
        <div>
          <el-tabs @tab-click="handleClick" v-model="tabName">
          <el-tab-pane label="个人微信" name="weChat2">
            <div v-if='wechatQrGenerateProcess==0'>
            <div class="tips" style="text-align:center;"><span>请上传个人微信二维码图片:</span></div>
              <el-upload :show-file-list="false" drag class="qr-src-uploader" style="margin-top:50px;" action="" :on-change="onUploadChange2" :multiple="false" :auto-upload="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将图片拖到此处，或
                <em>点击上传</em> 
              </div>
            </el-upload>
            <div class="tips" style="font-size:15px;color:#bbbbbb;margin-left:25%;">如何获取个人二维码？<br>1、打开微信，点击“我”<br>2、点击个人资料旁的二维码图标<br>3、点击右上角菜单将二维码保存至手机<br>Tip:为保证识别成功，请尽量选择黑白色的二维码（可以在微信个人微信界面选项中点击“换个样式”进行改变）</div>
            </div>
                      <div v-if="wechatQrGenerateProcess == 1" style="text-align: center;">
                        <div class="tips" style="text-align:center;"><span>请上传用于生成美钥二维码的图片:</span></div>
            <el-upload drag class="qr-src-uploader" style="margin-top:70px;" action="" :on-change="onUploadChange" :multiple="false" :auto-upload="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将图片拖到此处，或
                <em>点击上传</em> 
              </div>
            </el-upload>
            <el-button @click="wechatQrGenerateProcess--" class="button2">上一步</el-button>
          </div>
                    <div v-if="wechatQrGenerateProcess == 2" style="text-align: center;">
            <cropper :src="selectedPic.url" @api="getCropApi" class="cropper"></cropper>
            <el-button @click="wechatQrGenerateProcess--" class="button3">上一步</el-button>
            <el-button @click="cropImage" class="button4">生成美钥码</el-button>
          </div>
                    <div v-if="wechatQrGenerateProcess == 3">
            <div style="text-align:center;margin-top:20px;">
              <img :src="'/qrdata/temp/' + qr.qrfile" class="disqr" alt="美钥二维码">
            </div>
            <div class="button_box" style="text-align: center;">
              <el-button @click="wechatQrGenerateProcess--" class="buttson5">重新裁剪</el-button>
              <el-button @click="saveQr" class="button6">保存图片</el-button>
            </div>
          </div>
          </el-tab-pane>
                      <el-tab-pane label="微信公众号" name="weChat">
          <!-- 第一个步骤 填写内容 -->
          <div v-if='wechatQrGenerateProcess==0' >
            <div class="tips" style="text-align:center;"><span>请输入微信公众号的微信号:</span></div>
            <el-form label-position="top" :model="qrWechatName">
              <el-form-item>
                <el-input class="input" placeholder="在这里输入微信公众号" v-model="weChatName"></el-input>
              </el-form-item>
              <el-form-item style="text-align: center;">
                <el-button class="button1" @click="secondStep()">下一步</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 第二个步骤  上传图像 -->
          <div v-if="wechatQrGenerateProcess == 1" style="text-align: center;">
            <el-upload drag class="qr-src-uploader" action="" :on-change="onUploadChange" :multiple="false" :auto-upload="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将图片拖到此处，或
                <em>点击上传</em> 
              </div>
            </el-upload>
            <el-button @click="wechatQrGenerateProcess--" class="button2">上一步</el-button>
          </div>
          <!-- 第三个步骤  裁剪图像 -->
          <div v-if="wechatQrGenerateProcess == 2" style="text-align: center;">
            <cropper :src="selectedPic.url" @api="getCropApi" class="cropper"></cropper>
            <el-button @click="wechatQrGenerateProcess--" class="button3">上一步</el-button>
            <el-button @click="cropImage" class="button4">生成美钥码</el-button>
          </div>
          <!-- 第四个步骤，预览生成的图片进行下一步操作 -->
          <div v-if="wechatQrGenerateProcess == 3">
            <div style="text-align:center;margin-top:20px;">
              <img :src="'/qrdata/temp/' + qr.qrfile" class="disqr" alt="美钥二维码">
            </div>
            <div class="button_box" style="text-align: center;">
              <el-button @click="wechatQrGenerateProcess--" class="button5">重新裁剪</el-button>
              <el-button @click="saveQr" class="button6">保存图片</el-button>
            </div>
          </div>
          </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="scale-fit">
        </div>
      </el-col>
    </div>
  </div>
</template>

<script type="text/javascript">
import $ from 'jquery'
import cropper from './cropper.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    cropper
  },
  data () {
    return {
      wechatQrGenerateProcess: 0,
      weChatName: '',
      selectedPic: '', // 上传的图像本地文件地址及名称，blob
      cropperApi: undefined,
      qr: undefined, // 生成的二维码
      qrText: '', // 二维码包含的链接
      tabName: 'weChat2' // 选项卡
    }
  },
  computed: {
    ...mapGetters(['logined', 'username'])
  },
  mounted () {
    document.title = '美钥二维码 - 制作微信美钥码'
  },
  methods: {
    secondStep () {
      const vm = this
      let ImgObj = new Image() // 判断图片是否存在
      ImgObj.onload = function () {
        vm.wechatQrGenerateProcess++
      }
      ImgObj.onerror = function () {
        vm.$message.error('输入的微信号有误，请重新输入')
      }
      ImgObj.src = 'http://open.weixin.qq.com/qr/code?username=' + vm.weChatName
    },
    onUploadChange (file) {
      const vm = this
      // 进入第3步
      vm.selectedPic = file
      vm.wechatQrGenerateProcess = vm.wechatQrGenerateProcess + 1
    },
    handleClick () {
      const vm = this
      vm.wechatQrGenerateProcess = 0
    },
    // 接受个人二维码图片
    onUploadChange2 (file) {
      const vm = this
      let formData = new FormData()
      formData.append('pic', file.raw)
      // 尝试对图片进行解码
      $.ajax({
        type: 'POST',
        url: '/v1/generate/decodeqr',
        data: formData,
        async: false,
        enctype: 'multipart/form-data',
        processData: false,  // 告诉jQuery不要去处理发送的数据
        contentType: false,   // 告诉jQuery不要去设置Content-Type请求头
        cache: false,
        success: function (response) {
          if (response.code === 200) {
            if (response.data != null) {
              vm.qrText = response.data
              // 进入第2步
              vm.wechatQrGenerateProcess = vm.wechatQrGenerateProcess + 1
            } else {
              vm.$message.error('无法识别图片中有效二维码信息，请重新选择！')
            }
          } else {
            vm.$message.error('请求错误，请稍后再试！')
          }
        }
      })
    },
    getCropApi (api) {
      this.cropperApi = api
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    cropImage () {
      const vm = this
      if (vm.cropperApi) {
        let canvas = vm.cropperApi.getCroppedCanvas({
          width: 512
        })
        let canvasDataURL = canvas.toDataURL('image/jpeg')
        let blob = vm.dataURLtoBlob(canvasDataURL)
        // 上传图像，并进行图像生成
        let formData = new FormData()
        formData.append('url', vm.weChatName)
        formData.append('srcImage', blob, 'cropImage.jpg')
        formData.append('resource', vm.qrText)
        if (vm.tabName === 'weChat') {
          formData.append('type', 'weChat')
        } else {
          formData.append('type', 'weChat2')
        }
        $.ajax({
          url: '/v1/generate/qr',
          type: 'POST',
          data: formData,
          async: false,
          enctype: 'multipart/form-data',
          processData: false,  // 告诉jQuery不要去处理发送的数据
          contentType: false,   // 告诉jQuery不要去设置Content-Type请求头
          cache: false
        })
        .done(function (data) {
          // 接受生成的二维码信息数据
          vm.qr = data.data
          // 跳转到下个界面
          vm.wechatQrGenerateProcess ++
        })
        .fail(function () {
          vm.$message.error('请求错误，请稍后再试！')
        })
      }
    },
        // 保存生成的美钥码
    saveQr () {
      const vm = this
      vm.$http.put(`/v1/user/qrs/${vm.qr.qrid}/owner`)
      .then(response => {
        if (response.data.code === 200) {
          vm.$message.info('保存成功！')
          vm.$router.push('/labelManage/labelid/all/n/10/p/1')
        } else {
          vm.$message.error('保存失败，请稍后再试')
        }
      }).catch((error) => {
        console.log(error)
        if (error.response.status === 507) {
          // 空间资源不足
          if (error.response.data.code === 507001) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者清理部分空间后重试。')
          // 二维码空间不足
          } else if (error.response.data.code === 507002) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者删除部分二维码后重试。')
          }
        }
      })
    }
  }
}
</script>

<style type="text/css" scoped>
/* 手机屏幕模拟 */
.scale-fit{
  width: 0px;
  height: 0px;
  transform: scale(0.6);
  transform-origin:0 0;
  -ms-transform: scale(0.6); /* IE 9 */
  -ms-transform-origin:0 0;     /* IE 9 */
  -moz-transform: scale(0.6); /* Firefox */
  -moz-transform-origin:0 0;    /* Firefox */
  -webkit-transform: scale(0.6); /* Safari and Chrome */
  -webkit-transform-origin:0 0; /* Safari 和 Chrome */
  -o-transform: scale(0.6); /* Opera */
  -o-transform-origin:0 0;    /* Opera */
}
.tips{
  margin: 100px auto 0px auto;
  font-weight: bold;
  font-size: 20px;
}
.input{
  clear: both;
  width:50%;
  margin: 0px 0px 0px 25%;
  /* padding:0; */
}
/* crop */
/* Limit image width to avoid overflow the container */
#imageCrop {
  max-width: 80%; /* This rule is very important, please do not ignore this! */
  border: 1px dashed #d9d9d9;
}
@media (max-width: 420px) {
  .button1,
  .button2 {
    width: 80%;
    margin: 0 10%;
    font-size: 15px;
    letter-spacing: 0px;
  }
}

</style>
